export const PaypalChangeAccountType = {
  ADD_NEW_ACCOUNT: 'add_new',
  SELECT_ACTUAL_ACCOUNT: 'actual_account',
};
